import type { HowToStep } from './schema'

interface Props {
  steps: HowToStep[]
  heading: string
}

export function ToolHowTo({ steps, heading }: Props) {
  if (steps.length === 0) return null
  return (
    <section className="mt-10" aria-labelledby="tool-howto-heading">
      <h2
        id="tool-howto-heading"
        className="mb-4 text-xl font-semibold tracking-tight text-foreground"
      >
        {heading}
      </h2>
      <ol className="space-y-4">
        {steps.map((step, i) => (
          <li key={i} className="flex gap-4">
            <span
              aria-hidden="true"
              className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-muted text-sm font-semibold text-foreground"
            >
              {i + 1}
            </span>
            <div>
              <p className="text-sm font-medium text-foreground">{step.name}</p>
              <p className="mt-0.5 text-sm text-foreground/80">{step.text}</p>
            </div>
          </li>
        ))}
      </ol>
    </section>
  )
}
